"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationEnum = void 0;

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/* eslint-disable @typescript-eslint/restrict-template-expressions */

/* eslint-disable @typescript-eslint/ban-types */

/* eslint-disable @typescript-eslint/no-unsafe-call */

/* eslint-disable @typescript-eslint/no-unsafe-assignment */

/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** @jsxImportSource @emotion/react */


var isEqual_1 = tslib_1.__importDefault(require("lodash-es/isEqual"));

var react_1 = require("react");

var swiper_1 = tslib_1.__importDefault(require("swiper"));

require("swiper/dist/css/swiper.css");

var styles = tslib_1.__importStar(require("./Swiper.style"));

var Pagination_1 = tslib_1.__importDefault(require("./Pagination"));

function bySlideId(slideA, slideB) {
  return slideA.id - slideB.id;
}

var PaginationEnum;

(function (PaginationEnum) {
  PaginationEnum["FRACTION"] = "fraction";
  PaginationEnum["BULLETS"] = "bullets";
  PaginationEnum["DYNAMICBULLETS"] = "dynamicbullets";
})(PaginationEnum = exports.PaginationEnum || (exports.PaginationEnum = {}));

function CustomSwiper(_ref) {
  var className = _ref.className,
      _ref$customActiveInde = _ref.customActiveIndex,
      customActiveIndex = _ref$customActiveInde === void 0 ? 0 : _ref$customActiveInde,
      _ref$slides = _ref.slides,
      slides = _ref$slides === void 0 ? [] : _ref$slides,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {
    loop: false,
    on: {}
  } : _ref$options,
      _ref$paginationType = _ref.paginationType,
      paginationType = _ref$paginationType === void 0 ? PaginationEnum.FRACTION : _ref$paginationType,
      _ref$renderPagination = _ref.renderPagination,
      renderPagination = _ref$renderPagination === void 0 ? true : _ref$renderPagination,
      _ref$preventTransitio = _ref.preventTransitionEnd,
      preventTransitionEnd = _ref$preventTransitio === void 0 ? false : _ref$preventTransitio,
      children = _ref.children,
      handleCustomSlideChange = _ref.handleCustomSlideChange,
      onClick = _ref.onClick;

  var _react_1$useState = react_1.useState(customActiveIndex),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      activeIndex = _react_1$useState2[0],
      setActiveIndex = _react_1$useState2[1];

  var containerRef = react_1.useRef(null);
  var swiperRef = react_1.useRef(null);
  var slicedSlides = react_1.useRef(PaginationEnum.BULLETS ? slides.slice(0, 20) : slides);
  var bulletOptions = {
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets'
    }
  };
  var fractionOptions = {
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
      renderFraction: function renderFraction(currentClass, totalClass) {
        return "\n          <span>\n            <span class=".concat(currentClass, "></span> / <span class=").concat(totalClass, "> </span>\n          </span>\n        ");
      }
    }
  };
  var paginationOptionData = {
    fraction: fractionOptions,
    bullets: bulletOptions
  };
  var handleActiveSlideChange = react_1.useCallback(function () {
    if (!swiperRef.current) {
      return;
    }

    var draftIndex = swiperRef.current.realIndex;
    var isLoopMode = options.loop;
    var isEdgeSlide = draftIndex === 0 || draftIndex === slicedSlides.current.length - 1; // loop mode인 경우 양 끝에 duplicated slide가 추가되어
    // 실제 slide와 index가 달라짐
    // 이를 보정하기 위한 처리

    if (isLoopMode && isEdgeSlide) {
      window.setTimeout(function () {
        if (swiperRef.current) {
          swiperRef.current.slideToLoop(draftIndex, 0, false);
        }
      }, 300);
    }
  }, [options.loop, slides.length]);
  var handleTransitionEnd = react_1.useCallback(function (swiper) {
    if (preventTransitionEnd) {
      return;
    }

    setActiveIndex(swiper.activeIndex);
    handleCustomSlideChange && handleCustomSlideChange(swiper.activeIndex);
  }, [handleCustomSlideChange, preventTransitionEnd]);
  var initializeSwiper = react_1.useCallback(function () {
    var on = options.on,
        otherOptions = tslib_1.__rest(options, ["on"]); // dynamicbullets는 swiper에서 지원하는 표준이 아니므로 제외


    var excludedDynamicBullets = paginationType === PaginationEnum.DYNAMICBULLETS ? PaginationEnum.BULLETS : paginationType;
    var paginationOptions = renderPagination ? paginationOptionData[excludedDynamicBullets] : {};
    var swiperOptions = Object.assign(Object.assign({
      on: Object.assign(Object.assign({}, on), {
        slideChange: handleActiveSlideChange
      })
    }, paginationOptions), otherOptions); // eslint-disable-next-line no-new

    if (containerRef.current && swiperRef.current === null) {
      swiperRef.current = new swiper_1.default(containerRef.current, Object.assign(Object.assign({}, swiperOptions), {
        onTransitionEnd: handleTransitionEnd
      }));
    }
  }, [handleActiveSlideChange, handleTransitionEnd, options, paginationType, renderPagination]);

  function destroySwiper() {
    if (swiperRef.current) {
      swiperRef.current.destroy(true, false);
    }
  }

  react_1.useEffect(function () {
    initializeSwiper();
  }, [initializeSwiper]);
  var prevSlidesRef = react_1.useRef();
  react_1.useEffect(function () {
    prevSlidesRef.current = slicedSlides.current;
  }, [slicedSlides.current]);
  react_1.useEffect(function () {
    var prevSlides = prevSlidesRef.current;
    var areSlidesUpdated = !isEqual_1.default(prevSlides.slice().sort(bySlideId), slicedSlides.current.slice().sort(bySlideId));

    if (areSlidesUpdated) {
      destroySwiper();
      initializeSwiper();
    }
  }, [initializeSwiper, slicedSlides.current]);
  react_1.useEffect(function () {
    if (!swiperRef.current) {
      return;
    }

    var shouldMoveSlideIndex = customActiveIndex > -1 && customActiveIndex !== swiperRef.current.activeIndex;

    if (shouldMoveSlideIndex) {
      swiperRef.current.slideTo(customActiveIndex);
    }
  }, [customActiveIndex]);
  var moveToActiveIndex = react_1.useCallback(function (targetIndex) {
    if (!swiperRef.current) {
      return;
    } // 기존에 사용하던 slideTo 함수에 버그 존재


    if (activeIndex < targetIndex) {
      swiperRef.current.slideNext();
      setActiveIndex(activeIndex + 1);
    }

    if (activeIndex > targetIndex) {
      swiperRef.current.slidePrev();
      setActiveIndex(activeIndex - 1);
    }
  }, [swiperRef.current, activeIndex]);
  return jsx_runtime_1.jsx("div", Object.assign({
    className: className,
    css: styles.wrapper,
    onClick: onClick
  }, {
    children: jsx_runtime_1.jsxs("div", Object.assign({
      className: "swiper-container",
      ref: containerRef,
      css: styles.container
    }, {
      children: [jsx_runtime_1.jsx("div", Object.assign({
        className: "swiper-wrapper",
        css: styles.swiperWrapper
      }, {
        children: slicedSlides.current.map(function (slide) {
          return jsx_runtime_1.jsx("div", Object.assign({
            className: "swiper-slide"
          }, {
            children: children(slide)
          }), slide.id);
        })
      }), void 0), renderPagination && jsx_runtime_1.jsx(Pagination_1.default, {
        isNotSingleSlide: slicedSlides.current.length > 1,
        paginationType: paginationType,
        activeIndex: activeIndex,
        slideLength: slicedSlides.current.length,
        dispatchActiveIndex: moveToActiveIndex
      }, void 0)]
    }), void 0)
  }), void 0);
}

exports.default = CustomSwiper;